var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            )
              return null
            return _vm.cancel.apply(null, arguments)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
            return _vm.handleEnter.apply(null, arguments)
          },
        ],
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Patch Builder")]),
          ]),
          _c(
            "v-card-text",
            [
              _c("div", { staticClass: "mb-3" }, [
                _c("strong", [_vm._v("Current Config ID:")]),
                _c("span", { staticClass: "text--secondary" }, [
                  _vm._v(_vm._s(_vm.currConfigUID)),
                ]),
              ]),
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.availableConfigs,
                  loading: _vm.isLoading,
                  dense: "",
                  outlined: "",
                  "item-text": "name",
                  "item-value": "uid",
                  "return-object": "",
                  "hide-details": "",
                  label: "Select base config to compare with",
                  placeholder: "Choose a config...",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _c("v-list-item-subtitle", [
                              _vm._v(_vm._s(item.uid)),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedConfig,
                  callback: function ($$v) {
                    _vm.selectedConfig = $$v
                  },
                  expression: "selectedConfig",
                },
              }),
              _vm.errorMessage
                ? _c("div", { staticClass: "error--text mt-2" }, [
                    _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "", disabled: _vm.isLoading },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    disabled: !_vm.canBuildPatch,
                    loading: _vm.isLoading,
                  },
                  on: { click: _vm.buildPatch },
                },
                [_vm._v(" Build Patch ")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }